import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VendorProAction } from "../../../Redux/action/VendorProAction";
import { VendorProfile as VendorProfileAction } from "../../../Redux/action/VendorProfileAction";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js/max";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../../utils/CropImg";
import { LocationForm } from "./locationData";
import "./VendorProfile.scss";

// ===== Material UI =====
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Divider,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  TextareaAutosize,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewProfile from "./ViewProfile";

// ================== SHARED WRAPPER (moved OUTSIDE to avoid remounts) ==================
const SectionWrapper = ({
  title,
  sectionKey,
  onSave,
  isSaveDisabled,
  children,
  editMode,
  setEditMode,
}) => {
  const inEdit = editMode[sectionKey];

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 3, mb: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: "#286a94" }}>
          {title}
        </Typography>

        {!inEdit ? (
          <Button
            variant="outlined"
            size="small"
            sx={{
              textTransform: "uppercase",
              borderColor: "#286a94",
              color: "#286a94",
              "&:hover": {
                backgroundColor: "#286a94",
                color: "#fff",
                borderColor: "#286a94",
              },
            }}
            startIcon={<EditIcon />}
            onClick={() =>
              setEditMode((prev) => ({ ...prev, [sectionKey]: true }))
            }
          >
            Edit
          </Button>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              disabled={isSaveDisabled}
              sx={{
                textTransform: "uppercase",
                backgroundColor: "#286a94",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#1e5474",
                },
              }}
              onClick={() => {
                onSave();
                setEditMode((prev) => ({ ...prev, [sectionKey]: false }));
              }}
            >
              Save
            </Button>

            <Button
              variant="outlined"
              color="error"
              onClick={() =>
                setEditMode((prev) => ({ ...prev, [sectionKey]: false }))
              }
            >
              Cancel
            </Button>
          </Stack>
        )}
      </Box>

      <Divider sx={{ mb: 2 }} />
      <Box>{children}</Box>
    </Paper>
  );
};

const VendorProfile = () => {
  const dispatch = useDispatch();
  const { userResult } = useSelector((state) => state.Auth);
  const id = userResult?.vendorid;

  const userInfo = useSelector((state) => state?.VendorProfile?.result);

  const [locations, setLocations] = useState([
    { country: "", city: "", state: "", address: "", locationType: "" },
  ]);

  const [errors, setErrors] = useState({});
  const [showOverlay, setShowOverlay] = useState(false);
  const [profilePercent, setProfilePercent] = useState(0);

  const [tempPro, setTempPro] = useState();
  const [cropModal, setCropModal] = useState(false);
  const [fileData, setFileData] = useState(); // company logo
  const [fileData2, setFileData2] = useState(); // profile image
  const [countryCode, setCountryCode] = useState("in");

  const [state, setState] = useState({
    vendorId: "",
    firstName: "",
    lastName: "",
    vendorEmailId: "",
    mobile: "",
    companyWebsite: "",
    vendorDesignation: "",
    city: "",
    state1: "",
    dialCode: "",
    country: "",
    address: "",
    description: "",
    experience: "",
    whatsApp: "",
    company: "",
    organizationEmailId: "",
    website: "",
    orgPhone: "",
    orgLocation: "",
    panNumber: "",
    gstNumber: "",
    governmentId: "",
    governmentTaxId: "",
    countryCode: "in",
  });

  const [panFile, setPanFile] = useState(null);
  const [gstFile, setGstFile] = useState(null);
  const [msaFile, setMsaFile] = useState(null);
  const [ndaFile, setNdaFile] = useState(null);
  const [msaFilePreview, setMsaFilePreview] = useState(null);
  const [ndaFilePreview, setNdaFilePreview] = useState(null);
  const [panFilePreview, setPanFilePreview] = useState(null);
  const [gstFilePreview, setGstFilePreview] = useState(null);

  const [governmentIdFile, setGovernmentIdFile] = useState(null);
  const [governmentIdPreview, setGovernmentIdPreview] = useState(null);

  const [governmentTaxIdFile, setGovernmentTaxIdFile] = useState(null);
  const [governmentTaxIdPreview, setGovernmentTaxIdPreview] = useState(null);

  const [uploadImageData, setUploadImageData] = useState({});
  const [currentTab, setCurrentTab] = useState("personal"); // "personal" | "company" | "documents"
  const [editMode, setEditMode] = useState({
    personal: false,
    company: false,
    documents: false,
  });

  const [showView, setShowView] = useState(true);

  // Cropper
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const { firstName, lastName, mobile, company } = state;
  const isIndian =
    (state?.countryCode || userInfo?.countryCode || "in").toLowerCase() ===
    "in";

  // ========= Fetch completion percentage =========
  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (id) {
  //       try {
  //         const res = await getPercentage(id);
  //         const percent = res?.data || 0;
  //         setProfilePercent(percent);
  //         if (percent === 100) {
  //           setIsSubmitted(true);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching percentage:", error);
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [id]);

  // ========= Fetch profile =========
  useEffect(() => {
    if (id) {
      dispatch(VendorProfileAction(id));
    }
  }, [dispatch, id]);

  // ========= Initialize from userInfo =========
  useEffect(() => {
    if (!userInfo) return;

    setState((prev) => ({
      ...prev,
      vendorId: userInfo?.vendorId || "",
      firstName: userInfo?.firstName || "",
      lastName: userInfo?.lastName || "",
      vendorEmailId: userInfo?.email || "",
      mobile: userInfo?.mobile || "",
      companyWebsite: userInfo?.companyWebsite || "",
      vendorDesignation: userInfo?.designation || "",
      city: userInfo?.city || "",
      state: userInfo?.state || "",
      country: userInfo?.country || "",
      countryCode: userInfo?.countryCode || "in",
      dialCode: userInfo?.dialCode || "",
      address: userInfo?.address || "",
      description: userInfo?.description || "",
      experience: userInfo?.experience || "",
      whatsApp: userInfo?.whatsApp || "",
      company: userInfo?.company || "",
      organizationEmailId: "",
      website: "",
      orgPhone: "",
      orgLocation: "",
      gstNumber: userInfo?.gstNumber || "",
      panNumber: userInfo?.panNumber || "",
      governmentId: userInfo?.governmentId || "",
      governmentTaxId: userInfo?.governmentTaxId || "",
    }));

    setLocations(userInfo?.locations || []);

    setFileData(userInfo?.companyLogoUrl);
    setFileData2(userInfo?.vendorProfileImageUrl);
    setCountryCode(userInfo?.countryCode || "in");

    const handleUrlToPreviewOrFile = (url, setFile, setPreview) => {
      if (!url) return;
      const ext = url.split(".").pop()?.toLowerCase();
      if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
        setPreview(url);
      } else {
        setFile(url);
      }
    };

    handleUrlToPreviewOrFile(
      userInfo?.msadocUrl,
      setMsaFile,
      setMsaFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.ndadocUrl,
      setNdaFile,
      setNdaFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.panImageUrl,
      setPanFile,
      setPanFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.gstImageUrl,
      setGstFile,
      setGstFilePreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.governmentIdFileUrl,
      setGovernmentIdFile,
      setGovernmentIdPreview
    );
    handleUrlToPreviewOrFile(
      userInfo?.governmentTaxIdFileUrl,
      setGovernmentTaxIdFile,
      setGovernmentTaxIdPreview
    );
  }, [userInfo]);

  // ========= Validation =========
  const validateFields = () => {
    const fieldErrors = {};
    const numberRegex = /\d/;

    if (!firstName) {
      fieldErrors.firstName = "First Name is required";
    } else if (numberRegex.test(firstName)) {
      fieldErrors.firstName = "First Name should not contain numbers";
    }

    if (!lastName) {
      fieldErrors.lastName = "Last Name is required";
    } else if (numberRegex.test(lastName)) {
      fieldErrors.lastName = "Last Name should not contain numbers";
    }

    if (!mobile) {
      fieldErrors.mobile = "Mobile number is required";
    }

    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0;
  };

  // ========= Handlers =========
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeleteProfilePic = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    handleRemovePic();
  };

  const handleRemovePic = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      .custom-confirm-button {
        background-color: #286a94 !important;
        color: white;
        border-bottom: 1px solid rgb(57, 57, 57);
      }
      .custom-title {
        border-bottom: 0.5px solid #adadad;
        color: #286a94 !important;
        padding-bottom: 10px;
      }
      .msg-paragraph {
        margin-top:10px;
      }
    `;
    document.getElementsByTagName("head")[0].appendChild(style);

    const para = document.createElement("div");
    para.className = "custom-paragraph";
    para.innerText = "Are you sure you want to delete your profile picture?";

    const container = document.createElement("div");
    container.appendChild(para);

    Swal.fire({
      title: "Delete Image",
      html: container.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios
            .put(
              `${process.env.REACT_APP_API_PATH}/ebench/remove_vendor_profile?vendorId=${id}`
            )
            .then(() => {
              toast.success("Image deleted successfully");
              setCroppedAreaPixels(null);
            });
          dispatch(VendorProfileAction(id));
        } catch (error) {
          console.error("Error accepting:", error);
          Swal.fire(
            "Error",
            "There was an error accepting the invitation",
            "error"
          );
        }
      }
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const filesize = file.size / 1024 / 1024;
    if (filesize > 1) {
      e.target.value = null;
      return toast.error("Please Select Image less than 1MB");
    }

    setFileData(file);
    setUploadImageData({ companyLogo: file });
  };

  const onCropComplete = (croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileSize = file.size;
    if (fileSize < 4 * 1024) {
      toast.error("File size must be at least 4 KB");
      e.target.value = null;
      return;
    }
    if (fileSize > 1024 * 1024) {
      toast.error("File size exceeds 1 MB limit");
      e.target.value = null;
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setTempPro(reader.result);
      setCropModal(true);
      e.target.value = "";
    };
  };

  const handleCropSubmit = async () => {
    try {
      const croppedFile = await getCroppedImg(
        tempPro,
        croppedAreaPixels,
        "vendor_profile"
      );
      setFileData2(croppedFile);
      setCropModal(false);
    } catch (e) {
      console.error("Crop failed", e);
    }
  };

  const handleFileUpload = (event, setFile, setFilePreview) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileType = file.type.split("/")[0];

    if (file.size > 1048576) {
      event.target.value = null;
      toast.error("File size should not exceed 1 MB.");
      return;
    }

    if (fileType === "image" || file.type === "application/pdf") {
      setFile(file);
      if (fileType === "image") {
        setFilePreview(URL.createObjectURL(file));
      } else {
        setFilePreview(null);
      }
    } else {
      toast.error("Please upload only images or PDF files.");
    }
  };

  const handleDeleteFile = (setFile, setFilePreview, inputId) => {
    setFile(null);
    setFilePreview(null);
    const input = document.getElementById(inputId);
    if (input) input.value = null;
  };

  // ========= Submit Handlers =========
  const handleDocumentsSubmit = (e) => {
    if (e) e.preventDefault();

    if (isIndian && state?.panNumber) {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (!panRegex.test(state?.panNumber)) {
        return toast.error("Please enter a valid PAN number.");
      }
    }

    if (state?.gstNumber) {
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}$/;
      if (!gstRegex.test(state?.gstNumber)) {
        return toast.error("Please enter a valid GST number.");
      }
    }

    if (!isIndian) {
      if (!state.governmentId || !state.governmentTaxId) {
        return toast.error(
          "Government ID and Tax ID are required for non-Indian vendors."
        );
      }
      if (!governmentIdFile && !governmentIdPreview) {
        return toast.error("Government ID document is required.");
      }
      if (!governmentTaxIdFile && !governmentTaxIdPreview) {
        return toast.error("Government Tax document is required.");
      }
    } else {
      if (!state.panNumber) {
        return toast.error("PAN Number is required for Indian vendors.");
      }
      if (!panFile && !panFilePreview) {
        return toast.error("PAN Document is required.");
      }
    }

    const isValid = validateFields();
    if (!isValid) return;

    const content = {
      ...state,
      countryCode: state?.countryCode,
      dialCode: state?.dialCode,
      governmentId: state.governmentId,
      governmentTaxId: state.governmentTaxId,
    };

    const formData = new FormData();
    let totalSize = 0;

    if (msaFile instanceof File) totalSize += msaFile.size;
    if (ndaFile instanceof File) totalSize += ndaFile.size;
    if (panFile instanceof File) totalSize += panFile.size;
    if (gstFile instanceof File) totalSize += gstFile.size;
    if (uploadImageData?.companyLogo instanceof File)
      totalSize += uploadImageData.companyLogo.size;
    if (fileData2 instanceof File) totalSize += fileData2.size;
    if (governmentIdFile instanceof File) totalSize += governmentIdFile.size;
    if (governmentTaxIdFile instanceof File)
      totalSize += governmentTaxIdFile.size;

    if (totalSize > 1048576) {
      return toast.error("Total file size should not exceed 1 MB.");
    }

    formData.append("vendor", JSON.stringify(content));
    if (msaFile) formData.append("msa", msaFile);
    if (ndaFile) formData.append("nda", ndaFile);
    if (panFile) formData.append("pan", panFile);
    if (gstFile) formData.append("gst", gstFile);
    if (governmentIdFile) formData.append("governmentIdFile", governmentIdFile);
    if (governmentTaxIdFile)
      formData.append("governmentTaxIdFile", governmentTaxIdFile);

    if (uploadImageData?.companyLogo)
      formData.append("companyLogo", uploadImageData.companyLogo);
    if (fileData2) formData.append("profileImage", fileData2);

    dispatch(VendorProAction(formData)).then((res) => {
      if (res?.data) {
        dispatch(VendorProfileAction(id));
        setShowView(true);
      }
    });
  };

  const handleProfileSubmit = (e) => {
    if (e) e.preventDefault();

    const pattern = /^[A-Za-z]+$/;
    if (!pattern.test(state?.firstName)) {
      return toast.error("First name must contain only alphabetic characters");
    } else if (!pattern.test(state?.lastName)) {
      return toast.error("Last name must contain only alphabetic characters");
    }

    let mobileNumber = mobile.replace(/\s+/g, "");

    if (mobileNumber.startsWith("0")) {
      mobileNumber = mobileNumber.substring(1);
    }

    const fullNumber = `+${state.dialCode}${mobileNumber}`;
    console.log("Full Number:", fullNumber);
    if (!isValidPhoneNumber(fullNumber)) {
      toast.error("Invalid phone number");
      return;
    }

    if (firstName?.length < 2) {
      return toast.error("First name should be between 2-50 characters");
    }
    if (lastName?.length < 2) {
      return toast.error("Last name should be between 2-50 characters");
    }

    const content = {
      vendorId: state.vendorId,
      firstName: state.firstName,
      lastName: state.lastName,
      vendorEmailId: state.vendorEmailId,
      mobile: state.mobile,
      countryCode: state.countryCode,
      dialCode: state.dialCode,
    };

    const formData = new FormData();
    if (fileData2) formData.append("profileImage", fileData2);
    formData.append("vendor", JSON.stringify(content));

    dispatch(VendorProAction(formData)).then((res) => {
      if (res?.data) {
        toast.success("Personal details updated");
        dispatch(VendorProfileAction(id));
        setShowView(true);
      }
    });
  };

  const handleCompanySubmit = (e) => {
    if (e) e.preventDefault();

    const content = {
      vendorId: state.vendorId,
      companyWebsite: state.companyWebsite,
      company: state.company,
      description: state.description,
      locations: locations,
    };
    const formData = new FormData();
    if (uploadImageData?.companyLogo)
      formData.append("companyLogo", uploadImageData.companyLogo);
    formData.append("vendor", JSON.stringify(content));

    dispatch(VendorProAction(formData)).then((res) => {
      if (res?.data) {
        toast.success("Company details updated");
        dispatch(VendorProfileAction(id));
        setShowView(true);
      }
    });
  };

  // ========= Derived Valid Flags =========
  const hasMsa = msaFile || msaFilePreview;
  const hasNda = ndaFile || ndaFilePreview;

  const isPersonalDetailsValid =
    state?.firstName &&
    state?.lastName &&
    state?.vendorEmailId &&
    state?.mobile;

  const isCompanyDetailsValid =
    state?.company &&
    state?.companyWebsite &&
    locations[0]?.city &&
    locations[0]?.address &&
    locations[0]?.country &&
    locations[0]?.locationType &&
    state?.description;

  const isDocumentsValid = isIndian
    ? hasMsa && hasNda && state?.panNumber && (panFile || panFilePreview)
    : hasMsa &&
      hasNda &&
      state?.governmentId &&
      state?.governmentTaxId &&
      (governmentIdFile || governmentIdPreview) &&
      (governmentTaxIdFile || governmentTaxIdPreview);

  if (showView) {
    return <ViewProfile handleChange={() => setShowView(false)} />;
  }

  const PersonalSection = () => {
    const disabled = !editMode.personal;

    return (
      <>
        {/* Profile Picture */}
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Box
            sx={{
              width: 180,
              height: 180,
              borderRadius: "50%",
              overflow: "hidden",
              border: "2px solid #e0e0e0",
              position: "relative",
              cursor: disabled ? "default" : "pointer",
            }}
            onMouseOver={() => !disabled && setShowOverlay(true)}
            onMouseOut={() => !disabled && setShowOverlay(false)}
          >
            {fileData2 ? (
              <img
                src={
                  typeof fileData2 === "string"
                    ? fileData2
                    : URL.createObjectURL(fileData2)
                }
                alt="Profile"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color="#417f9c"
              >
                <Typography variant="body2">Select Image</Typography>
              </Box>
            )}

            {showOverlay && !disabled && (
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{
                  bgcolor: "rgba(0,0,0,0.4)",
                  color: "white",
                  transition: "0.2s",
                }}
                onClick={() =>
                  !disabled && document.getElementById("fileInput")?.click()
                }
              >
                <Typography variant="body2">Choose Image</Typography>
              </Box>
            )}

            {showOverlay && fileData2 && !disabled && (
              <IconButton
                size="small"
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: "50%",
                  transform: "translateX(50%)",
                  bgcolor: "white",
                  border: "1px solid red",
                }}
                onClick={handleDeleteProfilePic}
              >
                <DeleteIcon color="error" />
              </IconButton>
            )}

            <input
              id="fileInput"
              type="file"
              name="file"
              onChange={handleProfileChange}
              accept=".jpg, .jpeg, .jfif, .pjpeg, .pjp, .png, .svg, .webp, .tiff, .heif"
              style={{ display: "none" }}
              disabled={disabled}
            />
          </Box>

          <Typography
            variant="caption"
            color="primary"
            mt={1}
            textAlign="center"
          >
            Please upload a file greater than 4KB and smaller than 1MB.
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="First Name"
              name="firstName"
              value={state.firstName}
              onChange={handleInputChange}
              fullWidth
              disabled={disabled}
              required
              inputProps={{ maxLength: 50, pattern: "^[A-Za-z]+$" }}
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Last Name"
              name="lastName"
              value={state.lastName}
              onChange={handleInputChange}
              fullWidth
              disabled={disabled}
              required
              inputProps={{ maxLength: 50, pattern: "^[A-Za-z]+$" }}
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Email"
              name="vendorEmailId"
              value={state.vendorEmailId}
              fullWidth
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" gap={1} alignItems="flex-end">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginLeft: "15px",
                  gap: 1,
                }}
              >
                <PhoneInput
                  inputClass="vendorProfilePhoneInput"
                  country={countryCode}
                  enableSearch
                  onChange={(value, countryData) => {
                    if (disabled) return;
                    const newDialCode = countryData?.dialCode || "";
                    const newCountryCode =
                      countryData?.countryCode?.toLowerCase() || "in";

                    setState((prevState) => ({
                      ...prevState,
                      dialCode: newDialCode,
                      countryCode: newCountryCode,
                    }));
                    setCountryCode(newCountryCode);

                    const cleanedValue = value.replace(/\D/g, "");
                    const local = cleanedValue.startsWith(newDialCode)
                      ? cleanedValue.slice(newDialCode.length)
                      : cleanedValue;

                    setState((prevState) => ({
                      ...prevState,
                      mobile: local,
                    }));
                  }}
                  disableCountryCode={false}
                  disableDropdown={false}
                  countryCodeEditable={false}
                  inputProps={{
                    readOnly: true,
                  }}
                  disabled={disabled}
                  style={{ width: "auto" }}
                />
                <TextField
                  type="number"
                  label="Mobile Number"
                  name="mobile"
                  value={state?.mobile}
                  onChange={(e) => {
                    if (disabled) return;
                    const inputValue = e.target.value.slice(0, 15);
                    setState((prev) => ({ ...prev, mobile: inputValue }));
                  }}
                  fullWidth
                  disabled={disabled}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  };

  const CompanySection = () => {
    const disabled = !editMode.company;

    return (
      <>
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Company Website"
              name="companyWebsite"
              value={state.companyWebsite}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Company Name"
              name="company"
              value={company}
              onChange={handleInputChange}
              fullWidth
              required
              disabled={disabled}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginLeft: 2,
                borderRadius: 2,
                p: 2,
              }}
            >
              <Button
                variant="contained"
                size="small"
                component="label"
                startIcon={<CloudUploadIcon />}
                disabled={disabled}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#286a94",
                  "&:hover": { backgroundColor: "#1f5676" },
                }}
              >
                Upload Logo
                <input
                  hidden
                  type="file"
                  accept=".jpg, .jpeg, .png, .svg, .webp, .tiff, .heif"
                  onChange={handleFileChange}
                />
              </Button>

              <Box
                sx={{
                  width: 75,
                  height: 75,
                  borderRadius: 2,
                  border: "1px solid #ccc",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {fileData ? (
                  <>
                    <img
                      src={
                        typeof fileData === "string"
                          ? fileData
                          : URL.createObjectURL(fileData)
                      }
                      alt="Company Logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                    {!disabled && (
                      <IconButton
                        size="small"
                        onClick={() => setFileData(null)}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          bgcolor: "#fff",
                          boxShadow: 1,
                          "&:hover": { bgcolor: "#ffe5e5" },
                        }}
                      >
                        {/* Remove icon intentionally hidden */}
                      </IconButton>
                    )}
                  </>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      color: "#999",
                      textAlign: "center",
                      p: 1,
                    }}
                  >
                    No Logo
                  </Box>
                )}
              </Box>
            </Box>

            <Typography variant="caption" color="#286a94" mt={1}>
              Allowed formats: JPG, PNG, SVG — Max size: 1MB.
            </Typography>
          </Grid>
        </Grid>

        <Box mb={2}>
          <LocationForm
            locations={locations}
            setLocations={setLocations}
            disabled={!editMode.company}
          />
        </Box>

        <Box>
          <Typography
            variant="subtitle2"
            fontWeight={500}
            mb={0.5}
            sx={{ color: "#286a94" }}
          >
            Description *
          </Typography>

          <TextareaAutosize
            name="description"
            placeholder="Describe your company..."
            value={state.description}
            onChange={handleInputChange}
            minRows={4}
            maxLength={1500}
            disabled={disabled}
            style={{
              width: "100%",
              resize: "vertical",
              fontSize: "14px",
              padding: "12px",
              borderRadius: "8px",
              background: disabled ? "#f5f5f5" : "#fff",
              border: "1px solid #b5c8d3",
              outline: "none",
              transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            }}
            className="styled-textarea"
          />

          <Typography
            variant="caption"
            sx={{
              textAlign: "right",
              display: "block",
              mt: 0.5,
              color: "#6b6b6b",
            }}
          >
            {state.description?.length || 0}/1500
          </Typography>
        </Box>

        <Typography
          variant="caption"
          color="#286a94"
          mt={2}
          display="block"
          textAlign="center"
        >
          Please upload a file greater than 4KB and smaller than 1MB.
        </Typography>
      </>
    );
  };

  const DocumentsSection = () => {
    const disabled = !editMode.documents;

    return (
      <>
        <Grid container spacing={2}>
          {/* Indian fields */}
          {isIndian && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  label="PAN Number"
                  name="panNumber"
                  placeholder="ABCDEXXXXF"
                  value={state?.panNumber}
                  onChange={(e) => {
                    const value = e.target?.value.toUpperCase();
                    const regex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
                    if (
                      value === "" ||
                      regex.test(value) ||
                      value?.length <= 10
                    ) {
                      handleInputChange({
                        target: { name: "panNumber", value },
                      });
                    }
                  }}
                  fullWidth
                  required
                  disabled={userInfo?.isDocumentUploadLocked || disabled}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="GST Number (Optional)"
                  name="gstNumber"
                  placeholder="22AAAAA9999A1Z5"
                  value={state?.gstNumber}
                  fullWidth
                  disabled={
                    (userInfo?.isDocumentUploadLocked && userInfo?.gstNumber) ||
                    disabled
                  }
                  onChange={handleInputChange}
                />
              </Grid>
            </>
          )}

          {/* Non-Indian Fields */}
          {!isIndian && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Government ID Number"
                  name="governmentId"
                  value={state.governmentId}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  disabled={userInfo?.isDocumentUploadLocked || disabled}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Government Tax ID"
                  name="governmentTaxId"
                  value={state.governmentTaxId}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  disabled={userInfo?.isDocumentUploadLocked || disabled}
                />
              </Grid>
            </>
          )}

          {/* MSA */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" display="block" mb={0.5}>
              MSA Document{" "}
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            </Typography>
            <input
              className="form-control"
              id="msaDocument"
              type="file"
              name="msaDocument"
              accept=".pdf, .jpg, .jpeg, .png"
              onChange={(e) =>
                handleFileUpload(e, setMsaFile, setMsaFilePreview)
              }
              required={!(msaFile || msaFilePreview)}
              disabled={userInfo?.isDocumentUploadLocked || disabled}
            />
            {msaFilePreview && (
              <Box mt={1} textAlign="center">
                <a
                  href={msaFilePreview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={msaFilePreview}
                    alt="MSA Document Preview"
                    style={{
                      width: "100%",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                  />
                </a>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={() =>
                      handleDeleteFile(
                        setMsaFile,
                        setMsaFilePreview,
                        "msaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
            {msaFile && !msaFilePreview && (
              <Box mt={1} textAlign="center">
                <Typography variant="body2" fontWeight={600}>
                  {msaFile?.name ?? "View document"}
                </Typography>
                <IconButton
                  onClick={() =>
                    msaFile?.name
                      ? window.open(URL.createObjectURL(msaFile), "_blank")
                      : msaFile && window.open(msaFile, "_blank")
                  }
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    onClick={() =>
                      handleDeleteFile(
                        setMsaFile,
                        setMsaFilePreview,
                        "msaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
          </Grid>

          {/* GST doc */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" display="block" mb={0.5}>
              GST Document (Optional)
            </Typography>
            <input
              className="form-control"
              id="gstDocument"
              type="file"
              name="gstDocument"
              accept=".pdf, .jpg, .jpeg, .png"
              disabled={
                (userInfo?.gstImageUrl && userInfo?.isDocumentUploadLocked) ||
                disabled
              }
              onChange={(e) =>
                handleFileUpload(e, setGstFile, setGstFilePreview)
              }
            />
            {gstFilePreview && (
              <Box mt={1} textAlign="center">
                <a
                  href={gstFilePreview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={gstFilePreview}
                    alt="GST Document Preview"
                    style={{
                      width: "100%",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                  />
                </a>
                {(!userInfo?.gstImageUrl ||
                  !userInfo?.isDocumentUploadLocked) &&
                  !disabled && (
                    <IconButton
                      size="small"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        handleDeleteFile(
                          setGstFile,
                          setGstFilePreview,
                          "gstDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
              </Box>
            )}
            {gstFile && !gstFilePreview && (
              <Box mt={1} textAlign="center">
                <Typography variant="body2" fontWeight={600}>
                  {gstFile?.name ?? "View document"}
                </Typography>
                <IconButton
                  onClick={() =>
                    gstFile?.name
                      ? window.open(URL.createObjectURL(gstFile), "_blank")
                      : gstFile && window.open(gstFile, "_blank")
                  }
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
                {(!userInfo?.gstImageUrl ||
                  !userInfo?.isDocumentUploadLocked) &&
                  !disabled && (
                    <IconButton
                      onClick={() =>
                        handleDeleteFile(
                          setGstFile,
                          setGstFilePreview,
                          "gstDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
              </Box>
            )}
          </Grid>

          {/* NDA */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" display="block" mb={0.5}>
              NDA Document{" "}
              <span style={{ marginLeft: "4px", color: "red" }}>*</span>
            </Typography>
            <input
              className="form-control"
              id="ndaDocument"
              type="file"
              name="ndaDocument"
              accept=".pdf, .jpg, .jpeg, .png"
              onChange={(e) =>
                handleFileUpload(e, setNdaFile, setNdaFilePreview)
              }
              required={!(ndaFile || ndaFilePreview)}
              disabled={userInfo?.isDocumentUploadLocked || disabled}
            />
            {ndaFilePreview && (
              <Box mt={1} textAlign="center">
                <a
                  href={ndaFilePreview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={ndaFilePreview}
                    alt="NDA Document Preview"
                    style={{
                      width: "100%",
                      maxHeight: "100px",
                      objectFit: "contain",
                    }}
                  />
                </a>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={() =>
                      handleDeleteFile(
                        setNdaFile,
                        setNdaFilePreview,
                        "ndaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
            {ndaFile && !ndaFilePreview && (
              <Box mt={1} textAlign="center">
                <Typography variant="body2" fontWeight={600}>
                  {ndaFile?.name ?? "View document"}
                </Typography>
                <IconButton
                  onClick={() =>
                    ndaFile?.name
                      ? window.open(URL.createObjectURL(ndaFile), "_blank")
                      : ndaFile && window.open(ndaFile, "_blank")
                  }
                >
                  <VisibilityIcon color="primary" />
                </IconButton>
                {!userInfo?.isDocumentUploadLocked && !disabled && (
                  <IconButton
                    onClick={() =>
                      handleDeleteFile(
                        setNdaFile,
                        setNdaFilePreview,
                        "ndaDocument"
                      )
                    }
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                )}
              </Box>
            )}
          </Grid>

          {/* PAN or Government Tax Document */}
          {isIndian ? (
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" display="block" mb={0.5}>
                PAN Document{" "}
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              </Typography>
              <input
                className="form-control"
                id="panDocument"
                type="file"
                name="panDocument"
                accept=".pdf, .jpg, .jpeg, .png"
                onChange={(e) =>
                  handleFileUpload(e, setPanFile, setPanFilePreview)
                }
                required={!(panFile || panFilePreview)}
                disabled={userInfo?.isDocumentUploadLocked || disabled}
              />
              {panFilePreview && (
                <Box mt={1} textAlign="center">
                  <a
                    href={panFilePreview}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={panFilePreview}
                      alt="PAN Document Preview"
                      style={{
                        width: "100%",
                        maxHeight: "100px",
                        objectFit: "contain",
                      }}
                    />
                  </a>
                  {!userInfo?.isDocumentUploadLocked && !disabled && (
                    <IconButton
                      size="small"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        handleDeleteFile(
                          setPanFile,
                          setPanFilePreview,
                          "panDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </Box>
              )}
              {panFile && !panFilePreview && (
                <Box mt={1} textAlign="center">
                  <Typography variant="body2" fontWeight={600}>
                    {panFile?.name ?? "View document"}
                  </Typography>
                  <IconButton
                    onClick={() =>
                      panFile?.name
                        ? window.open(URL.createObjectURL(panFile), "_blank")
                        : panFile && window.open(panFile, "_blank")
                    }
                  >
                    <VisibilityIcon color="primary" />
                  </IconButton>
                  {!userInfo?.isDocumentUploadLocked && !disabled && (
                    <IconButton
                      onClick={() =>
                        handleDeleteFile(
                          setPanFile,
                          setPanFilePreview,
                          "panDocument"
                        )
                      }
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  )}
                </Box>
              )}
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" display="block" mb={0.5}>
                  Government ID Document{" "}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
                <input
                  type="file"
                  id="govIdDoc"
                  accept=".pdf, .jpg, .jpeg, .png"
                  disabled={disabled}
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      setGovernmentIdFile,
                      setGovernmentIdPreview
                    )
                  }
                />
                {governmentIdPreview && (
                  <Box mt={1} textAlign="center">
                    <img
                      src={governmentIdPreview}
                      alt="Government ID"
                      style={{
                        width: "100%",
                        maxHeight: 100,
                        objectFit: "contain",
                      }}
                    />
                    {!disabled && (
                      <IconButton
                        onClick={() =>
                          handleDeleteFile(
                            setGovernmentIdFile,
                            setGovernmentIdPreview,
                            "govIdDoc"
                          )
                        }
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    )}
                  </Box>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" display="block" mb={0.5}>
                  Government Tax Document
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
                <input
                  type="file"
                  id="govTaxDoc"
                  accept=".pdf, .jpg, .jpeg, .png"
                  disabled={disabled}
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      setGovernmentTaxIdFile,
                      setGovernmentTaxIdPreview
                    )
                  }
                />

                {governmentTaxIdPreview && (
                  <Box mt={1} textAlign="center">
                    <img
                      src={governmentTaxIdPreview}
                      alt="Government Tax Doc"
                      style={{
                        width: "100%",
                        maxHeight: 100,
                        objectFit: "contain",
                      }}
                    />
                    {!disabled && (
                      <IconButton
                        onClick={() =>
                          handleDeleteFile(
                            setGovernmentTaxIdFile,
                            setGovernmentTaxIdPreview,
                            "govTaxDoc"
                          )
                        }
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    )}
                  </Box>
                )}
              </Grid>
            </>
          )}
        </Grid>

        <Typography
          variant="caption"
          color="#286a94"
          mt={2}
          display="block"
          textAlign="center"
        >
          Please upload a file greater than 4KB and smaller than 1MB.
        </Typography>
      </>
    );
  };

  // ================== MAIN RETURN ==================
  return (
    <>
      <ToastContainer />

      {/* Crop Dialog */}
      <Dialog
        open={cropModal}
        onClose={() => setCropModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Crop Profile</DialogTitle>
        <DialogContent sx={{ height: 400 }}>
          <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
            <Cropper
              image={tempPro}
              crop={crop}
              cropShape="round"
              zoom={zoom}
              aspect={1}
              showGrid={false}
              restrictPosition={false}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              objectFit="cover"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="success"
            onClick={handleCropSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          my: 3,
          px: 2,
        }}
      >
        {/* Sidebar */}
        <Paper
          elevation={3}
          sx={{
            width: 260,
            borderRadius: 3,
            p: 2,
            height: "auto",
            position: "sticky",
            top: 80,
          }}
        >
          <Typography
            variant="h6"
            color="#286a94"
            fontWeight={700}
            textAlign="center"
            mb={2}
          >
            Vendor Profile
          </Typography>

          <Stack spacing={1.2}>
            {[
              {
                key: "personal",
                label: "Personal Details",
                valid: !!isPersonalDetailsValid,
              },
              {
                key: "company",
                label: "Company Details",
                valid: !!isCompanyDetailsValid,
              },
              {
                key: "documents",
                label: "Documents",
                valid: !!isDocumentsValid,
              },
            ].map((s) => {
              const isActive = currentTab === s.key;
              const inEdit = editMode[s.key];
              return (
                <Box
                  key={s.key}
                  onClick={() => setCurrentTab(s.key)}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 2,
                    px: 1.5,
                    py: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    transition: "0.2s",
                    bgcolor: isActive ? "#286a94" : "#ffffff",
                    color: isActive ? "#ffffff" : "#286a94",
                    border: isActive ? "none" : "1px solid #cdd8df",
                    "&:hover": {
                      bgcolor: isActive ? "#1f5575" : "#e8f2f7",
                      borderColor: "#286a94",
                    },
                  }}
                >
                  <Typography fontSize={14} fontWeight={500}>
                    {s.label}
                  </Typography>
                  {inEdit ? (
                    <Tooltip title="Editing">
                      <EditIcon
                        fontSize="small"
                        sx={{ color: isActive ? "#fff" : "#286a94" }}
                      />
                    </Tooltip>
                  ) : s.valid ? (
                    <Tooltip title="Completed">
                      <CheckCircleIcon
                        fontSize="small"
                        sx={{ color: isActive ? "#fff" : "#2e7d32" }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Pending">
                      <AccessTimeIcon
                        fontSize="small"
                        sx={{ color: isActive ? "#fff" : "#ed6c02" }}
                      />
                    </Tooltip>
                  )}
                </Box>
              );
            })}
          </Stack>
        </Paper>

        {/* Main content */}
        <Box sx={{ flex: 1 }}>
          {currentTab === "personal" && (
            <SectionWrapper
              title="Personal Details"
              sectionKey="personal"
              onSave={handleProfileSubmit}
              isSaveDisabled={!isPersonalDetailsValid}
              editMode={editMode}
              setEditMode={setEditMode}
            >
              {PersonalSection()}
            </SectionWrapper>
          )}
          {currentTab === "company" && (
            <SectionWrapper
              title="Company Details"
              sectionKey="company"
              onSave={handleCompanySubmit}
              isSaveDisabled={!isCompanyDetailsValid}
              editMode={editMode}
              setEditMode={setEditMode}
            >
              {CompanySection()}
            </SectionWrapper>
          )}
          {currentTab === "documents" && (
            <SectionWrapper
              title="Documents"
              sectionKey="documents"
              onSave={handleDocumentsSubmit}
              isSaveDisabled={!isDocumentsValid}
              editMode={editMode}
              setEditMode={setEditMode}
            >
              {DocumentsSection()}
            </SectionWrapper>
          )}
        </Box>

        {/* Right Notes Pane */}
        <Paper
          elevation={3}
          className="jc_notes_container"
          sx={{ p: 2, borderRadius: 3, minWidth: 260, maxWidth: 280 }}
        >
          <Typography
            color={"#286a94"}
            variant="subtitle1"
            fontWeight={700}
            mb={1.5}
          >
            Important Notes
          </Typography>
          <Divider />
          <Box mt={2} className="jc_notes">
            <Typography variant="body2" mb={1}>
              AI That Understands Hiring: eBench uses intelligent algorithms to
              match you with the right candidates—fast, accurately, and with
              zero guesswork.
            </Typography>
            <Typography variant="body2" mb={1}>
              Vetted Professionals Only: Every candidate is thoroughly assessed
              for skills, experience, and fit—saving you time and ensuring
              quality.
            </Typography>
            <Typography variant="body2" mb={1}>
              All-in-One Hiring Platform: Post jobs, manage candidates, schedule
              interviews, and onboard—all from one intuitive dashboard.
            </Typography>
            <Typography variant="body2" mb={1}>
              Reduce Time & Cost: Cut hiring time by up to 70% and avoid the
              costs of bad hires with data-backed decision-making.
            </Typography>
            <Typography variant="body2" mb={1}>
              Global Reach, Local Compliance: Find top remote talent while
              ensuring full compliance with employment laws across regions.
            </Typography>
            <Typography variant="body2" mb={1}>
              Custom Workflows: Tailor the platform for every industry and
              internal hiring processes—whether you're a startup or a large
              enterprise.
            </Typography>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default VendorProfile;

// ================== VIEW PROFILE  ==================
// const ViewProfile = ({ handleChange }) => {
//   const dispatch = useDispatch();
//   const userInfo = useSelector((state) => state?.VendorProfile?.result);
//   const { userResult } = useSelector((state) => state.Auth);
//   const id = userResult?.vendorid;
//   const [state, setState] = useState({
//     vendorId: "",
//     firstName: "",
//     lastName: "",
//     vendorEmailId: "",
//     mobile: "",
//     companyWebsite: "",
//     vendorDesignation: "",
//     city: "",
//     country: "",
//     address: "",
//     description: "",
//     experience: "",
//     whatsApp: "",
//     company: "",
//     organizationEmailId: "",
//     website: "",
//     orgPhone: "",
//     orgLocation: "",
//     panNumber: "",
//     gstNumber: "",
//     governmentTaxId: "",
//     governmentTaxFile: "",
//     governmentId: "",
//     governmentIdFile: "",
//   });
//   const isIndian = userInfo?.countryCode === "in";

//   const [panFile, setPanFile] = useState(null);
//   const [gstFile, setGstFile] = useState(null);
//   const [msaFile, setMsaFile] = useState(null);
//   const [ndaFile, setNdaFile] = useState(null);
//   const [msaFilePreview, setMsaFilePreview] = useState(null);
//   const [ndaFilePreview, setNdaFilePreview] = useState(null);
//   const [panFilePreview, setPanFilePreview] = useState(null);
//   const [gstFilePreview, setGstFilePreview] = useState(null);

//   const [governmentIdFile, setGovernmentIdFile] = useState(null);
//   const [governmentIdPreview, setGovernmentIdPreview] = useState(null);
//   const [governmentTaxIdFile, setGovernmentTaxIdFile] = useState(null);
//   const [governmentTaxIdPreview, setGovernmentTaxIdPreview] = useState(null);

//   const [locations, setLocations] = useState([
//     { country: "", city: "", address: "", locationType: "" },
//   ]);

//   useEffect(() => {
//     if (userInfo?.vendorId) {
//       setState({
//         vendorId: userInfo?.vendorId || "",
//         firstName: userInfo?.firstName || "",
//         lastName: userInfo?.lastName || "",
//         vendorEmailId: userInfo?.email || "",
//         mobile: userInfo?.mobile || "",
//         companyWebsite: userInfo?.companyWebsite || "",
//         vendorDesignation: userInfo?.designation || "",
//         city: userInfo?.city || "",
//         country: userInfo?.country || "",
//         dialCode: userInfo?.dialCode || "",
//         address: userInfo?.address || "",
//         description: userInfo?.description || "",
//         experience: userInfo?.experience || "",
//         whatsApp: userInfo?.whatsApp || "",
//         company: userInfo?.company || "",
//         organizationEmailId: "",
//         website: "",
//         orgPhone: "",
//         orgLocation: "",
//         gstNumber: userInfo?.gstNumber || "",
//         panNumber: userInfo?.panNumber || "",
//         governmentId: userInfo?.governmentId || "",
//         governmentTaxId: userInfo?.governmentTaxId || "",
//       });
//     }
//     setLocations(userInfo?.locations || []);

//     const handleUrlToPreviewOrFile = (url, setFile, setPreview) => {
//       if (!url) return;
//       const ext = url.split(".").pop().toLowerCase();
//       if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
//         setPreview(url);
//       } else {
//         setFile(url);
//       }
//     };

//     handleUrlToPreviewOrFile(
//       userInfo?.msadocUrl,
//       setMsaFile,
//       setMsaFilePreview
//     );
//     handleUrlToPreviewOrFile(
//       userInfo?.ndadocUrl,
//       setNdaFile,
//       setNdaFilePreview
//     );
//     handleUrlToPreviewOrFile(
//       userInfo?.panImageUrl,
//       setPanFile,
//       setPanFilePreview
//     );
//     handleUrlToPreviewOrFile(
//       userInfo?.gstImageUrl,
//       setGstFile,
//       setGstFilePreview
//     );
//     handleUrlToPreviewOrFile(
//       userInfo?.governmentIdFileUrl,
//       setGovernmentIdFile,
//       setGovernmentIdPreview
//     );
//     handleUrlToPreviewOrFile(
//       userInfo?.governmentTaxIdFileUrl,
//       setGovernmentTaxIdFile,
//       setGovernmentTaxIdPreview
//     );
//   }, [userInfo]);

//   const [fileData, setFileData] = useState();
//   const [fileData2, setFileData2] = useState();
//   useEffect(() => {
//     setFileData(userInfo?.companyLogoUrl);
//     setFileData2(userInfo?.vendorProfileImageUrl);
//   }, [userInfo]);

//   useEffect(() => {
//     dispatch(VendorProfileAction(id));
//   }, [dispatch, id]);

//   const { companyWebsite, description, company } = state;
//   const [showMSACertificates, setShowMSACertificates] = useState(false);
//   const [msaLoad, setMsaLoad] = useState(true);
//   const [showNDACertificates, setShowNDACertificates] = useState(false);
//   const [showPANCertificates, setShowPANCertificates] = useState(false);
//   const [showGSTCertificates, setShowGSTCertificates] = useState(false);

//   if (!state?.vendorId) {
//     return (
//       <div
//         style={{
//           height: "70vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Loader />
//       </div>
//     );
//   }
//   return (
//     <>
//       <div className="d-flex ven_main_prof_container my-3 can_prof_container">
//         <div className="jc_notes_container " style={{ height: "maxContent" }}>
//           <div className="ven_logo_container">
//             <div className="ven_logo_container">
//               <div
//                 className="label_job ven_pic_container "
//                 style={{
//                   width: "210px",
//                   height: "210px",
//                   overflow: "hidden",
//                   position: "relative",
//                   borderRadius: "50%",
//                 }}
//               >
//                 {fileData2 && (
//                   <>
//                     <img
//                       src={fileData2 ?? ""}
//                       alt="Profile"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="ven_prof_container">
//           <div
//             style={{ display: "flex", flexDirection: "column", gap: "20px" }}
//           >
//             <div className="card can_prof_main">
//               <div className="card-header prof_header d-flex justify-content-between">
//                 Profile Details
//                 <button className="edit_button" onClick={handleChange}>
//                   Edit
//                 </button>
//               </div>
//               <div className="card-body">
//                 <div>
//                   <div className="row gx-3 ">
//                     <div className="col-12 col-lg-6">
//                       <label className="small mb-1 fw_500">First Name</label>
//                       <div className="form-control">{state.firstName}</div>
//                     </div>
//                     <div className="col-12 col-lg-6">
//                       <label className="small mb-1 fw_500">Last Name</label>
//                       <div className="form-control">{state.lastName}</div>
//                     </div>
//                     <div className="col-12 col-lg-6">
//                       <label
//                         className="small mb-1 fw_500"
//                         htmlFor="vendorEmailId"
//                       >
//                         Email
//                       </label>
//                       <div className="form-control">{state.vendorEmailId}</div>
//                     </div>
//                     <div className="col-12 col-lg-6">
//                       <label
//                         className="small mb-1 fw_500"
//                         htmlFor="vendorEmailId"
//                       >
//                         Mobile
//                       </label>
//                       <div className="form-control">{state.mobile}</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div style={{ marginBottom: 20 }} className="card can_prof_main ">
//               <div className="card-header prof_header d-flex justify-content-between">
//                 Company Details
//               </div>
//               <div className="card-body">
//                 <div>
//                   <div className="row gx-3 mb-4 align-items-start">
//                     <div className="col-12 col-md-6 mb-3">
//                       <label className="small mb-1 fw_500">
//                         Company Website
//                       </label>
//                       <div
//                         className="form-control text-truncate"
//                         title={companyWebsite}
//                         style={{ cursor: "default" }}
//                       >
//                         {companyWebsite || "N/A"}
//                       </div>
//                     </div>

//                     <div className="col-12 col-md-6 mb-3">
//                       <label className="small mb-1 fw_500">Company Name</label>
//                       <div className="form-control">{company || "N/A"}</div>
//                     </div>

//                     <div className="col-12">
//                       <label className="small mb-2 fw_500 d-block">
//                         Company Logo
//                       </label>

//                       <div className="d-flex align-items-center">
//                         {fileData ? (
//                           <img
//                             src={
//                               typeof fileData === "string"
//                                 ? fileData
//                                 : URL.createObjectURL(fileData)
//                             }
//                             alt="Company Logo"
//                             style={{
//                               width: "150px",
//                               height: "150px",
//                               objectFit: "cover",
//                               borderRadius: "6px",
//                               border: "1px solid #dcdcdc",
//                               padding: "6px",
//                               background: "#fff",
//                             }}
//                           />
//                         ) : (
//                           <span className="text-muted small">
//                             No Logo Uploaded
//                           </span>
//                         )}
//                       </div>
//                     </div>
//                   </div>

//                   {locations
//                     ?.sort((a, b) =>
//                       a.locationType === "HEADQUARTERS" ? -1 : 1
//                     )
//                     ?.map((location, index) => (
//                       <div key={index} className="mb-4 border rounded p-3">
//                         <h6
//                           className="fw-bold mb-3 text-primary-custom"
//                           style={{ textTransform: "uppercase" }}
//                         >
//                           {location?.locationType?.slice(0, 11)} Office
//                         </h6>

//                         <div className="row gx-3">
//                           <div className="col-md-4">
//                             <label className="small mb-1  mt-2 fw_500">
//                               Country
//                             </label>
//                             <div className="form-control">
//                               {location.country}
//                             </div>
//                           </div>

//                           <div className="col-md-4">
//                             <label className="small mb-1 fw_500 mt-2">
//                               State
//                             </label>
//                             <div className="form-control">
//                               {location.state || "N/A"}
//                             </div>
//                           </div>

//                           <div className="col-md-4">
//                             <label className="small mb-1 fw_500 mt-2">
//                               City
//                             </label>
//                             <div className="form-control">{location.city}</div>
//                           </div>

//                           <div className="col-md-4">
//                             <label className="small mb-1 fw_500 mt-2">
//                               Address
//                             </label>
//                             <div className="form-control">
//                               {location.address}
//                             </div>
//                           </div>

//                           <div className="col-md-4">
//                             <label className="small mb-1 fw_500 mt-2">
//                               Location Type
//                             </label>
//                             <div className="form-control">
//                               {location.locationType}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))}

//                   <div className="row gx-3 mb-2x`">
//                     <div className="col-md-12">
//                       <label className="small mb-3 fw_500" htmlFor="mobile">
//                         Description
//                       </label>
//                       <div style={{ padding: 10 }} className="form-control">
//                         {description}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div style={{ marginBottom: 20 }} className="card can_prof_main ">
//               <div className="card-header prof_header fw_500 d-flex justify-content-between">
//                 Documents
//               </div>
//               <div className="card-body">
//                 <form>
//                   <div className="row gx-3 mb-3">
//                     <div className="col-md-4">
//                       <label className="small mb-1 fw_500">
//                         {isIndian ? "PAN Number" : "Government Tax ID"}
//                       </label>

//                       <div className="form-control">
//                         {isIndian
//                           ? state?.panNumber || "N/A"
//                           : state?.governmentTaxId || "N/A"}
//                       </div>
//                     </div>

//                     <div className="col-md-4">
//                       <label className="small mb-1 fw_500">GST Number</label>
//                       <div className="form-control">
//                         {state?.gstNumber ? state?.gstNumber : "N/A"}
//                       </div>
//                     </div>

//                     <div className="col-md-4">
//                       <label
//                         className="small mb-1 fw_500"
//                         htmlFor="msaDocument"
//                       >
//                         MSA Document
//                       </label>

//                       {msaFilePreview && (
//                         <div className="file-preview mt-2">
//                           <span
//                             style={{ cursor: "pointer" }}
//                             onClick={() => [
//                               setShowMSACertificates(true),
//                               setMsaLoad(true),
//                             ]}
//                             rel="noopener noreferrer"
//                           >
//                             <img
//                               src={msaFilePreview}
//                               alt="MSA Document Preview"
//                               style={{
//                                 width: "100%",
//                                 maxHeight: "100px",
//                                 objectFit: "contain",
//                               }}
//                             />
//                           </span>
//                         </div>
//                       )}
//                       {msaFile && (
//                         <div className="file-name mt-2">
//                           <div>
//                             <span style={{ fontSize: 14, fontWeight: 600 }}>
//                               {msaFile?.name ?? "View document"}
//                             </span>
//                             <span
//                               onClick={() =>
//                                 msaFile?.name
//                                   ? window.open(
//                                       URL.createObjectURL(msaFile),
//                                       "_blank"
//                                     )
//                                   : msaFile && window.open(msaFile, "_blank")
//                               }
//                               style={{
//                                 padding: 5,
//                                 borderRadius: 5,
//                                 color: "#286a94",
//                                 fontSize: 20,
//                                 cursor: "pointer",
//                               }}
//                             >
//                               <IoEyeOutline />
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="row gx-3 my-3">
//                     <div className="col-md-4">
//                       <label
//                         className="small mb-1 fw_500"
//                         htmlFor="gstDocument"
//                       >
//                         GST Document (Optional)
//                       </label>
//                       {gstFilePreview && (
//                         <div className="file-preview mt-2">
//                           <span
//                             style={{ cursor: "pointer" }}
//                             onClick={() => [
//                               setShowGSTCertificates(true),
//                               setMsaLoad(true),
//                             ]}
//                             rel="noopener noreferrer"
//                           >
//                             <img
//                               src={gstFilePreview}
//                               alt="GST Document Preview"
//                               style={{
//                                 width: "100%",
//                                 maxHeight: "100px",
//                                 objectFit: "contain",
//                               }}
//                             />
//                           </span>
//                         </div>
//                       )}

//                       {gstFile && (
//                         <div className="file-name mt-2">
//                           <div>
//                             <span style={{ fontSize: 14, fontWeight: 600 }}>
//                               {gstFile?.name ?? "View document"}
//                             </span>
//                             <span
//                               onClick={() =>
//                                 gstFile?.name
//                                   ? window.open(
//                                       URL.createObjectURL(gstFile),
//                                       "_blank"
//                                     )
//                                   : gstFile && window.open(gstFile, "_blank")
//                               }
//                               style={{
//                                 padding: 5,
//                                 borderRadius: 5,
//                                 color: "#286a94",
//                                 fontSize: 20,
//                                 cursor: "pointer",
//                               }}
//                             >
//                               <IoEyeOutline />
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                     <div className="col-md-4">
//                       <label
//                         className="small mb-1 fw_500"
//                         htmlFor="ndaDocument"
//                       >
//                         NDA Document
//                         <span
//                           style={{ color: "red", paddingLeft: 4 }}
//                           className="text-red-700 pl-[2px]"
//                         >
//                           *
//                         </span>
//                       </label>

//                       {ndaFilePreview && (
//                         <div className="file-preview mt-2">
//                           <span
//                             style={{ cursor: "pointer" }}
//                             onClick={() => [
//                               setShowNDACertificates(true),
//                               setMsaLoad(true),
//                             ]}
//                             rel="noopener noreferrer"
//                           >
//                             <img
//                               src={ndaFilePreview}
//                               alt="NDA Document Preview"
//                               style={{
//                                 width: "100%",
//                                 maxHeight: "100px",
//                                 objectFit: "contain",
//                               }}
//                             />
//                           </span>
//                         </div>
//                       )}
//                       {ndaFile && !ndaFilePreview && (
//                         <div className="file-name mt-2">
//                           <div>
//                             <span style={{ fontSize: 14, fontWeight: 600 }}>
//                               {ndaFile?.name ?? "View document"}
//                             </span>
//                             <span
//                               onClick={() =>
//                                 ndaFile?.name
//                                   ? window.open(
//                                       URL.createObjectURL(ndaFile),
//                                       "_blank"
//                                     )
//                                   : ndaFile && window.open(ndaFile, "_blank")
//                               }
//                               style={{
//                                 padding: 5,
//                                 borderRadius: 5,
//                                 color: "#286a94",
//                                 fontSize: 20,
//                                 cursor: "pointer",
//                               }}
//                             >
//                               <IoEyeOutline />
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                     <div className="col-md-4">
//                       <label
//                         className="small mb-1 fw_500"
//                         htmlFor="panDocument"
//                       >
//                         {isIndian ? "PAN" : "Government Tax"} Document
//                         <span
//                           style={{ color: "red", paddingLeft: 4 }}
//                           className="text-red-700 pl-[2px]"
//                         >
//                           *
//                         </span>
//                       </label>

//                       {panFilePreview && (
//                         <div className="file-preview mt-2">
//                           <div>
//                             <span
//                               style={{ cursor: "pointer" }}
//                               onClick={() => [
//                                 setShowPANCertificates(true),
//                                 setMsaLoad(true),
//                               ]}
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={panFilePreview}
//                                 alt="PAN Document Preview"
//                                 style={{
//                                   width: "100%",
//                                   maxHeight: "100px",
//                                   objectFit: "contain",
//                                 }}
//                               />
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                       {panFile && !panFilePreview && (
//                         <div className="file-name mt-2">
//                           <div>
//                             <span style={{ fontSize: 14, fontWeight: 600 }}>
//                               {panFile?.name ?? "View document"}
//                             </span>
//                             <span
//                               onClick={() =>
//                                 panFile?.name
//                                   ? window.open(
//                                       URL.createObjectURL(panFile),
//                                       "_blank"
//                                     )
//                                   : panFile && window.open(panFile, "_blank")
//                               }
//                               style={{
//                                 padding: 5,
//                                 borderRadius: 5,
//                                 color: "#286a94",
//                                 fontSize: 20,
//                                 cursor: "pointer",
//                               }}
//                             >
//                               <IoEyeOutline />
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {!isIndian && (
//                     <div className="row gx-3 my-3">
//                       <div className="col-md-6">
//                         <label className="small mb-1 fw_500">
//                           Government ID Document
//                         </label>
//                         {governmentIdPreview && (
//                           <div className="file-preview mt-2">
//                             <span
//                               style={{ cursor: "pointer" }}
//                               onClick={() => {
//                                 setShowPANCertificates(true);
//                                 setMsaLoad(true);
//                               }}
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={governmentIdPreview}
//                                 alt="Government ID Preview"
//                                 style={{
//                                   width: "100%",
//                                   maxHeight: "100px",
//                                   objectFit: "contain",
//                                 }}
//                               />
//                             </span>
//                           </div>
//                         )}
//                         {governmentIdFile && !governmentIdPreview && (
//                           <div className="file-name mt-2">
//                             <div>
//                               <span style={{ fontSize: 14, fontWeight: 600 }}>
//                                 {governmentIdFile?.name ?? "View document"}
//                               </span>
//                               <span
//                                 onClick={() =>
//                                   governmentIdFile?.name
//                                     ? window.open(
//                                         URL.createObjectURL(governmentIdFile),
//                                         "_blank"
//                                       )
//                                     : governmentIdFile &&
//                                       window.open(governmentIdFile, "_blank")
//                                 }
//                                 style={{
//                                   padding: 5,
//                                   borderRadius: 5,
//                                   color: "#286a94",
//                                   fontSize: 20,
//                                   cursor: "pointer",
//                                 }}
//                               >
//                                 <IoEyeOutline />
//                               </span>
//                             </div>
//                           </div>
//                         )}
//                       </div>

//                       <div className="col-md-6">
//                         <label className="small mb-1 fw_500">
//                           Government Tax Document
//                         </label>
//                         {governmentTaxIdPreview && (
//                           <div className="file-preview mt-2">
//                             <span
//                               style={{ cursor: "pointer" }}
//                               onClick={() => {
//                                 setShowGSTCertificates(true);
//                                 setMsaLoad(true);
//                               }}
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={governmentTaxIdPreview}
//                                 alt="Government Tax Preview"
//                                 style={{
//                                   width: "100%",
//                                   maxHeight: "100px",
//                                   objectFit: "contain",
//                                 }}
//                               />
//                             </span>
//                           </div>
//                         )}
//                         {governmentTaxIdFile && !governmentTaxIdPreview && (
//                           <div className="file-name mt-2">
//                             <div>
//                               <span style={{ fontSize: 14, fontWeight: 600 }}>
//                                 {governmentTaxIdFile?.name ?? "View document"}
//                               </span>
//                               <span
//                                 onClick={() =>
//                                   governmentTaxIdFile?.name
//                                     ? window.open(
//                                         URL.createObjectURL(
//                                           governmentTaxIdFile
//                                         ),
//                                         "_blank"
//                                       )
//                                     : governmentTaxIdFile &&
//                                       window.open(governmentTaxIdFile, "_blank")
//                                 }
//                                 style={{
//                                   padding: 5,
//                                   borderRadius: 5,
//                                   color: "#286a94",
//                                   fontSize: 20,
//                                   cursor: "pointer",
//                                 }}
//                               >
//                                 <IoEyeOutline />
//                               </span>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   )}
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="jc_notes_container common_shadow p-3">
//           <p className="jc_notes_head">Important Notes</p>
//           <div className="line_divide"></div>
//           <div className="jc_notes mt-3">
//             <p>
//               AI That Understands Hiring: eBench uses intelligent algorithms to
//               match you with the right candidates—fast, accurately, and with
//               zero guesswork.
//             </p>
//             <p>
//               Vetted Professionals Only: Every candidate is thoroughly assessed
//               for skills, experience, and fit—saving you time and ensuring
//               quality.
//             </p>
//             <p>
//               All-in-One Hiring Platform: Post jobs, manage candidates, schedule
//               interviews, and onboard—all from one intuitive dashboard.
//             </p>
//             <p>
//               Reduce Time & Cost: Cut hiring time by up to 70% and avoid the
//               costs of bad hires with data-backed decision-making.
//             </p>
//             <p>
//               Global Reach, Local Compliance: Find top remote talent while
//               ensuring full compliance with employment laws across regions.
//             </p>
//             <p>
//               Custom Workflows: Tailor the platform for every industry and
//               internal hiring processes—whether you're a startup or a large
//               enterprise.
//             </p>
//           </div>
//         </div>
//       </div>
//       {showMSACertificates && (
//         <VideoModal
//           showModal={showMSACertificates}
//           handleClose={() => setShowMSACertificates(false)}
//           title={`MSA Document`}
//           newWindow={true}
//           resumeUrl={userInfo?.MSADocUrl}
//           body={
//             <div
//               className="profile-video d-flex justify-content-center"
//               style={{ margin: "0 auto", height: "80vh" }}
//             >
//               {msaLoad && (
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <p style={{ color: "blue" }}>
//                     <SpinLoader />
//                   </p>
//                 </div>
//               )}
//               {userInfo?.MSADocUrl ? (
//                 <img
//                   style={{
//                     display: msaLoad ? "none" : "block",
//                     objectFit: "contain",
//                     width: "100%",
//                     height: "100%",
//                   }}
//                   src={userInfo.MSADocUrl}
//                   alt="Purchase Order"
//                   onLoad={() => setMsaLoad(false)}
//                   onError={() => setMsaLoad(false)}
//                 />
//               ) : (
//                 <p>No file available.</p>
//               )}
//             </div>
//           }
//         />
//       )}
//       {showNDACertificates && (
//         <VideoModal
//           showModal={showNDACertificates}
//           handleClose={() => setShowNDACertificates(false)}
//           title={`MSA Document`}
//           newWindow={true}
//           resumeUrl={userInfo?.NDADocUrl}
//           body={
//             <div
//               className="profile-video d-flex justify-content-center"
//               style={{ margin: "0 auto", height: "80vh" }}
//             >
//               {msaLoad && (
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <p style={{ color: "blue" }}>
//                     <SpinLoader />
//                   </p>
//                 </div>
//               )}
//               {userInfo?.NDADocUrl ? (
//                 <img
//                   style={{
//                     display: msaLoad ? "none" : "block",
//                     objectFit: "contain",
//                     width: "100%",
//                     height: "100%",
//                   }}
//                   src={userInfo.NDADocUrl}
//                   alt="Purchase Order"
//                   onLoad={() => setMsaLoad(false)}
//                   onError={() => setMsaLoad(false)}
//                 />
//               ) : (
//                 <p>No file available.</p>
//               )}
//             </div>
//           }
//         />
//       )}
//       {showPANCertificates && (
//         <VideoModal
//           showModal={showPANCertificates}
//           handleClose={() => setShowPANCertificates(false)}
//           title={`${isIndian ? "PAN" : "Government Tax"} Document`}
//           newWindow={true}
//           resumeUrl={userInfo?.panImageUrl}
//           body={
//             <div
//               className="profile-video d-flex justify-content-center"
//               style={{ margin: "0 auto", height: "80vh" }}
//             >
//               {msaLoad && (
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <p style={{ color: "blue" }}>
//                     <SpinLoader />
//                   </p>
//                 </div>
//               )}
//               {userInfo?.panImageUrl ? (
//                 <img
//                   style={{
//                     display: msaLoad ? "none" : "block",
//                     objectFit: "contain",
//                     width: "100%",
//                     height: "100%",
//                   }}
//                   src={userInfo.panImageUrl}
//                   alt="Purchase Order"
//                   onLoad={() => setMsaLoad(false)}
//                   onError={() => setMsaLoad(false)}
//                 />
//               ) : (
//                 <p>No file available.</p>
//               )}
//             </div>
//           }
//         />
//       )}

//       {showGSTCertificates && (
//         <VideoModal
//           showModal={showGSTCertificates}
//           handleClose={() => setShowGSTCertificates(false)}
//           title={`MSA Document`}
//           newWindow={true}
//           resumeUrl={userInfo?.gstImageUrl}
//           body={
//             <div
//               className="profile-video d-flex justify-content-center"
//               style={{ margin: "0 auto", height: "80vh" }}
//             >
//               {msaLoad && (
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <p style={{ color: "blue" }}>
//                     <SpinLoader />
//                   </p>
//                 </div>
//               )}
//               {userInfo?.gstImageUrl ? (
//                 <img
//                   style={{
//                     display: msaLoad ? "none" : "block",
//                     objectFit: "contain",
//                     width: "100%",
//                     height: "100%",
//                   }}
//                   src={userInfo.gstImageUrl}
//                   alt="GST Document"
//                   onLoad={() => setMsaLoad(false)}
//                   onError={() => setMsaLoad(false)}
//                 />
//               ) : (
//                 <p>No file available.</p>
//               )}
//             </div>
//           }
//         />
//       )}
//     </>
//   );
// };
